import React, { useState } from 'react';
import { campusesData } from '../data/mock';
import { Dumbbell, ShoppingBag, Video, Clapperboard, Bot, Apple } from 'lucide-react';
import { useTheme } from '../ThemeContext';
import PortalTransition from './MatrixTransition';
import { useT } from '../i18n/useT';

const iconMap = { Dumbbell, ShoppingBag, Video, Clapperboard, Bot, Apple };

const CampusesSection = () => {
  const { isDark } = useTheme();
  const t = useT();
  const tc = isDark ? '#FFFFFF' : '#1B2A4A';
  const campuses = campusesData.campuses;
  const campusTexts = t.campuses.items;
  const [showMatrix, setShowMatrix] = useState(false);

  return (
    <>
      {showMatrix && <PortalTransition />}
      <section className="relative mt-20 px-[30px] lg:px-0" id="professions">
        <div className="mx-auto max-w-[1408px]">
          <h3 className="text-center text-[13px] tracking-[0.35em] font-medium uppercase transition-colors duration-300" style={{ fontFamily: '"Inter", sans-serif', color: isDark ? '#E6EBF2' : tc }}>{t.campuses.label}</h3>
          <h2 className="text-center text-[32px] lg:text-[48px] font-bold mt-1 transition-colors duration-300" style={{ fontFamily: '"Space Grotesk", sans-serif', color: tc }}>{t.campuses.title}</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-8 px-4">
            {campuses.map((campus, index) => {
              const IconComponent = iconMap[campus.lucideIcon];
              const txt = campusTexts[index] || {};
              return (
                <article
                  key={index}
                  data-testid={`campus-card-${index}`}
                  onClick={() => setShowMatrix(true)}
                  className={`rounded-lg hover:bg-black w-full group cursor-pointer transition-all duration-500 ${isDark ? 'tech-border' : ''}`}
                  style={{ backgroundColor: isDark ? '#07070f' : '#F2F2F2' }}
                >
                  <img alt={`Campus-${txt.name}`} loading="lazy" width="416" height="197" className="w-full rounded-t-lg object-cover h-[197px]" src={campus.image} />
                  <div className="w-full p-4">
                    <div className="flex gap-3 items-center">
                      <div className="w-[44px] h-[44px] min-h-[44px] min-w-[44px] flex items-center justify-center rounded-lg transition-all duration-500" style={{ backgroundColor: isDark ? 'rgba(0,212,255,0.08)' : '#E0E0E0' }}>
                        {IconComponent && <IconComponent size={24} className="transition-all duration-500" style={{ color: isDark ? '#E6EBF2' : '#1B2A4A' }} />}
                      </div>
                      <h6 className="group-hover:text-white transition-all duration-500 text-[16px] font-bold" style={{ fontFamily: '"Space Grotesk", sans-serif', color: isDark ? '#FFFFFF' : 'black' }}>{txt.name}</h6>
                    </div>
                    <p className="copy-text group-hover:text-white mt-4 transition-all duration-500 text-[14px] leading-[1.6]" style={{ fontFamily: '"Inter", sans-serif', color: isDark ? 'rgba(255,255,255,0.5)' : 'black' }} dangerouslySetInnerHTML={{ __html: txt.description }} />
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default CampusesSection;
